export const SPACING = {
  size2: '2px',
  size4: '4px',
  size8: '8px',
  size12: '12px',
  size16: '16px',
  size20: '20px',
  size24: '24px',
  size32: '32px',
  size40: '40px',
  size48: '48px',
  size52: '56px',
  size56: '56px',
  size64: '64px',
  size72: '72px',
  size80: '80px',
  size96: '96px',
  size112: '112px',
  size128: '128px',
  size144: '144px',
  size160: '160px',
  size192: '192px',
  size224: '224px',
  size256: '256px',
  size320: '320px',
  size384: '384px',
  size512: '512px',
  size576: '576px',
  size640: '640px',
  size720: '720px',
  size768: '768px'
};
